import React from 'react';

import * as S from './styles';

const Footer = () => {
  return (
    <>
      <S.Footer>
        <b>Made with ❤ by KUCC</b>
        <br />
        <div>회장 명재위 | 010-3096-8941</div>
        <div>부회장 김채린 | 010-8628-8084</div>
        <div>부회장 박성철 | 010-6355-8791</div>
        <br />
        <div>anamkucc314@gmail.com</div>
        <br />
        <div>서울특별시 성북구 고려대로 105 고려대학교 학생회관 314호</div>
        <br />
        <div>Copyright ⓒ KUCC All rights reserved.</div>
      </S.Footer>
    </>
  );
};

export default Footer;
